import { createAsyncThunk } from '@reduxjs/toolkit';
import Axios from 'axios';
import { postGetPrivateProjectBankFileUploadSignedUrl } from 'scenes/ProjectBank/services/private-project-bank/getPrivateProjectBankFileUploadSignedUrl.service';
import { postPrivateProjectBankItem } from 'scenes/ProjectBank/services/private-project-bank/postPrivateProjectBankItem.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectSelectedPrivateProjectBankFolderId } from '../../selectors/project-bank.selectors';
import { previewUploadedModelFile } from 'scenes/ProjectBank/utils/bankModelPreview';

export const uploadPrivateProjectBankFile = createAsyncThunk(
  'project-bank/uploadPrivateProjectBankFile',
  async ({ fileType, file }, { getState, dispatch }) => {
    const projectId = selectSelectedProjectId(getState());

    const parentFolderId = selectSelectedPrivateProjectBankFolderId(getState());

    const uploadSignedUrlData =
      await postGetPrivateProjectBankFileUploadSignedUrl(projectId, fileType);

    if (uploadSignedUrlData) {
      const options = {
        headers: {
          'Content-Type': fileType,
        },
      };

      const { uploadUrl, fileId } = uploadSignedUrlData;

      await Axios.put(uploadUrl, file, options);

      const privateFileAttributes = {
        name: file.name,
        mimeType: fileType,
        size: file.size,
        fileId,
        parentFolderId: parentFolderId || undefined,
      };

      const response = await postPrivateProjectBankItem(
        projectId,
        privateFileAttributes
      );

      // A 3D model gets its tile picture drawn from the file in hand, in the
      // background (queued, so the item is in the state by the time it lands).
      previewUploadedModelFile({
        dispatch,
        target: { mode: 'PRIVATE', id: fileId, projectId },
        file,
      });

      return response;
    }
  }
);
